import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AuthInterceptor, AppRootTranslationModule, UiInitializationService } from "@core";
import { ServiceWorkerModule } from "@angular/service-worker";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ConfettiOverlayComponent, NotificationContainerComponent } from "@components";
import { AppErrorService } from "./core/error/app-error.service";
import { AppErrorOverlayComponent } from "./components/overlays/app-error-overlay/app-error-overlay.component";

function initializeUi(_uiInitializationService: UiInitializationService) {
  return (): void => {
    _uiInitializationService.initializeUi();
  };
}

// prettier-ignore
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AppRootTranslationModule,
    ConfettiOverlayComponent,
    ServiceWorkerModule.register("my-service-worker.js", {
      enabled: true,
      // enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: "registerWhenStable:30000",
    }),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: "toast-bottom-full-width",
    }),
    NotificationContainerComponent,
    AppErrorOverlayComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeUi,
      multi: true,
      deps: [UiInitializationService],
    },
    {
      // processes all errors
      provide: ErrorHandler,
      useClass: AppErrorService,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
